import { createFileRoute } from '@tanstack/react-router';
import Loader from '../../components/Loader/Loader';
import PageGray from '../../components/General/PageGray';
import ProfileData from '../../components/Profile/ProfileData';
import ProfilePrivacy from '../../components/Profile/ProfilePrivacy';
import ProfileLanguage from '../../components/Profile/ProfileLanguage';
import ProfileAvatarName from '../../components/Profile/ProfileAvatarName';
import ProfileHeader from '../../components/Profile/ProfileHeader';
import ProfileDelete from '../../components/Profile/ProfileDelete';
import GeneralError from '../../components/Errors/General';
import { useGetProfile } from '../../hooks/profile/useProfile';

export const Route = createFileRoute('/_sidebar/profilo')({
  component: RouteComponent,
});

function RouteComponent() {
  const { profile, isFetching, error } = useGetProfile();

  if (isFetching) {
    return <Loader fullScreen />;
  }

  if (error || !profile) {
    return <GeneralError />;
  }

  return (
    <PageGray className="flex flex-col gap-8">
      <ProfileHeader />
      <div className="flex flex-col gap-6">
        <ProfileAvatarName profile={profile} />
        <ProfileData profile={profile} />
        <ProfileLanguage />
        <ProfilePrivacy profile={profile} />
        <ProfileDelete />
      </div>
    </PageGray>
  );
}
